import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import React__default, { forwardRef } from 'react';
import { themed } from '@indeed/ifl-css';
import { ChevronUp, ChevronDown } from '@indeed/ifl-icons';
import { InputWrapper } from '../Input/InputWrapper.js';
import { jsx } from '@emotion/react';
import { baseStyles, inputStyles } from '../Input/Input.js';
import { Button } from '../Button/Button.js';
import { Flex } from '../Flex/Flex.js';
import '../../utils/transition.js';
import '../../utils/styled.js';
import '../TouchTarget/TouchTarget.js';
import '../Text/Text.js';
import '../../utils/createResponsive.js';
import '../../constants/index.js';
import '../../utils/mergeRefs.js';
import '../../hooks/useHasFocus.js';
import '../../utils/warn.js';
import '../../hooks/useCheckValidity.js';
import '../Input/ChipInput.js';
import '@indeed/ihl-use-id';
import '../Input/styles.js';
import '../Input/AutosizeInput.js';
import '../../hooks/useIsomorphicLayoutEffect.js';
import '../Chip/ChipGroup.js';
import '../Chip/Chip.js';
import '@emotion/is-prop-valid';
import '../../hooks/useResponsiveValue.js';
import '../../hooks/useBreakpointIndex.js';
import '../Label/Label.js';
import '../VisuallyHidden/VisuallyHidden.js';
import '../../utils/transparentize.js';
import '../Button/context.js';
import '../IndeedThemeProvider/hooks/useColorMode.js';
import '../IndeedThemeProvider/hooks/useColorModeAttribute.js';
import '../Spinner/Spinner.js';
import '../IconWrapper/IconWrapper.js';
import '../../utils/displayName.js';
import '../Box/Box.js';

const StyledSuggestListInput = /*#__PURE__*/themed("input", process.env.NODE_ENV === "production" ? {
  styleProps: ["contentBefore", "contentAfter", "size"],
  shouldForwardProp: prop => prop !== "contentBefore" && prop !== "contentAfter" && prop !== "size",
  target: "ehiczq0"
} : {
  styleProps: ["contentBefore", "contentAfter", "size"],
  shouldForwardProp: prop => prop !== "contentBefore" && prop !== "contentAfter" && prop !== "size",
  target: "ehiczq0",
  label: "StyledSuggestListInput"
})(baseStyles, inputStyles, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
const SuggestListInput = /*#__PURE__*/forwardRef((props, forwardedRef) => {
  const {
    contentAfter,
    contentBefore,
    disabled = false,
    invalid = false,
    canOpen,
    isOpen,
    size = "md",
    setPopupAnchor,
    toggleButtonProps = {
      "aria-label": "Show suggestions"
    },
    toggleButtonRef,
    openPopup,
    closePopup,
    hideToggleButton = false,
    messageId,
    ...remainingProps
  } = props;
  const ariaDescribedBy = [remainingProps["aria-describedby"], messageId].filter(value => value !== undefined).filter(Boolean).join(" ") || undefined;
  return jsx(InputWrapper, {
    ref: setPopupAnchor,
    size: size,
    disabled: disabled,
    invalid: invalid,
    contentBefore: contentBefore,
    contentAfter:
    // Need to conditionally render this fragment only if either contentAfter
    // is provided or hideToggleButton is false, otherwise we get an empty span
    // that still takes up this space even when there is nothing there.
    contentAfter || !hideToggleButton ? jsx(React__default.Fragment, null, contentAfter && jsx(Flex, {
      sx: {
        marginInlineEnd: hideToggleButton ? 0 : 1
      }
    }, contentAfter), !hideToggleButton && jsx(Button, _extends({
      iconOnly: true,
      ref: toggleButtonRef,
      "aria-controls": props["aria-controls"],
      "aria-describedby": ariaDescribedBy,
      "aria-expanded": props["aria-expanded"],
      "aria-hidden": false,
      "aria-haspopup": "listbox",
      type: "button",
      size: "sm",
      variant: "tertiary",
      sx: {
        minInlineSize: "unset",
        minBlockSize: "unset",
        paddingBlockStart: 0,
        paddingBlockEnd: 0,
        paddingInlineStart: 0,
        paddingInlineEnd: 0,
        /**
         * Ensure minimum touch target size.
         *
         * `Button` does not leverage `TouchTarget`. Instead, it uses
         * `calc` to add an additional `10px` to the parent's height.
         * Removing the `padding` above results in the size of the
         * `::before` element falling below `44px`.
         */
        "::before": {
          minInlineSize: 44,
          minBlockSize: 44
        }
      },
      tabIndex: -1,
      onClick: () => {
        if (isOpen) {
          closePopup();
        } else if (canOpen) {
          openPopup();
        }
      }
    }, toggleButtonProps), isOpen && canOpen ? jsx(ChevronUp, {
      "aria-hidden": true
    }) : jsx(ChevronDown, {
      "aria-hidden": true
    }))) : null
  }, jsx(StyledSuggestListInput, _extends({
    ref: forwardedRef
    // FIXME: fix this type error
    // @ts-ignore
    ,
    size: size,
    contentBefore: contentBefore,
    contentAfter: contentAfter,
    disabled: disabled
  }, remainingProps, {
    defaultValue: undefined,
    "aria-describedby": ariaDescribedBy
  })));
});

export { SuggestListInput };
